module.exports = __webpack_public_path__ + "img/jo1.6d7ee1d3.png";